import React from 'react';
export function SmartAskAmountsInfo() {
  return <div className="bg-[#EFF6FF] border border-[#0047AB]/20 rounded-lg p-4 mt-4" data-id="element-294" data-mp="2i6yzrwy8qumd">
      <div className="flex items-start gap-3" data-id="element-295" data-mp="221s3f96k7a00">
        <div className="flex-shrink-0 w-5 h-5 bg-[#0047AB] rounded-full flex items-center justify-center mt-0.5" data-id="element-296" data-mp="1o92k5cif0j6l">
          <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-297" data-mp="1s9mey9finapk">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-298" data-mp="2fy5o0r6e3rip" />
          </svg>
        </div>
        <div className="flex-1" data-id="element-299" data-mp="2bxlrnptn4rxm">
          <h4 className="text-sm font-semibold text-gray-900 mb-2" data-id="element-300" data-mp="2bwtuiakeam58">
            To unlock Smart Ask Amounts and Smart Segments, please upload 5 full
            years of Giving History.
          </h4>
          <div className="text-sm text-gray-700" data-id="element-301" data-mp="10ksycal7bvfg">
            <p className="font-medium mb-2" data-id="element-302" data-mp="138x5oxu4547q">Requirements:</p>
            <ul className="space-y-1 ml-4" data-id="element-303" data-mp="13bjd8xh07jpy">
              <li className="flex items-start" data-id="element-304" data-mp="yavraq7mtt2l">
                <span className="font-medium mr-2" data-id="element-305" data-mp="yc6twmpccus4">Total Span:</span>
                <span data-id="element-306" data-mp="1d8o4hbppi5dm">
                  There must be a full 5-year difference between the date of
                  your oldest gift and your most recent gift.
                </span>
              </li>
              <li className="flex items-start" data-id="element-307" data-mp="1m700xud97xdz">
                <span className="font-medium mr-2" data-id="element-308" data-mp="1h97za8mt4wwl">Continuity:</span>
                <span data-id="element-309" data-mp="1h8y6yeeaidnq">
                  You must have at least one gift recorded in every single year.
                </span>
              </li>
              <li className="flex items-start" data-id="element-310" data-mp="1qzaxcn8sd11s">
                <span className="font-medium mr-2" data-id="element-311" data-mp="1qzjbsjkk4ef3">Freshness:</span>
                <span data-id="element-312" data-mp="24y0uu3zip2qo">
                  Your data must be current. If no gifts are present from the
                  last 6 months, these features will be locked.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}